import styled from 'styled-components';

const JoinUsStyles = styled.div`
  svg {
    margin-bottom: 30px;
  }
`;

export default JoinUsStyles;
